import * as React from 'react';
import { Location } from 'history';
import { CategoryTile } from './CategoryTiles/CategoryTile';
import { VideoTile } from './CategoryTiles/VideoTile';
import { TileIndex } from '../Common/TileIndex';
import { SiteMeta } from '../Utils/SiteMeta';
import { Advert, Category, Video } from '../../models';
import './style.css';

export interface CategoryIndexProps {
  advertSlotOne?: Array<Advert>;
  advertSlotTwo?: Array<Advert>;
  category: Category;
  location: Location;
}

export interface CategoryIndexState {
  /* empty*/
}

class CategoryTileIndex extends TileIndex<Category | Video> {}

export class CategoryIndex extends React.Component<
  CategoryIndexProps,
  CategoryIndexState
> {
  render() {
    const { advertSlotOne, advertSlotTwo, category } = this.props;

    const items = category.parent ? category.videos : category.children;

    return (
      <main className="category-index" role="main">
        <SiteMeta
          title={`Edge of Play | ${category.name}`}
          description={category.description}
          image={category.image}
          url={category.route}
        />
        <h1 className="category-header">{category.name}</h1>
        <p className="category-description">{category.description}</p>
        <CategoryTileIndex
          items={items}
          getTile={this.getCategoryTile}
          advertSlotOne={advertSlotOne}
          advertSlotTwo={advertSlotTwo}
        />
      </main>
    );
  }

  private getCategoryTile(categoryOrVideo: Category | Video): JSX.Element {
    if (categoryOrVideo instanceof Category) {
      return (
        <CategoryTile key={categoryOrVideo.name} category={categoryOrVideo} />
      );
    }

    return <VideoTile key={categoryOrVideo.name} video={categoryOrVideo} />;
  }
}

export default CategoryIndex;



// WEBPACK FOOTER //
// ./src/app/components/CategoryIndex/index.tsx